import styled from "styled-components";
import BackgroundImage from 'gatsby-background-image'

export const HeroWrapper = styled(BackgroundImage) `
    height: 770px;
    display: flex;
    align-items: center;
`;

export const HeroTextBox = styled.div `
    text-align: center;
`;